export const normalizeRole = (role) => {
  const value = String(role || '').toUpperCase();
  if (value === 'ADMIN') return 'SUPER_ADMIN';
  if (value === 'USER') return 'VENDEDOR';
  return value;
};

export const getLoggedUser = () => {
  try {
    const raw = localStorage.getItem('kardex_user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.user && typeof parsed.user === 'object') {
      return { ...parsed.user, token: parsed.token || null };
    }
    return parsed;
  } catch (error) {
    return null;
  }
};

export const hasRole = (allowedRoles = [], user = getLoggedUser()) => {
  const role = normalizeRole(user?.role);
  return allowedRoles.map(normalizeRole).includes(role);
};

export const ROLE_ACCESS = {
  SUPER_ADMIN: {
    inventory: ['products', 'suppliers', 'kardex-movements', 'document-register', 'tapers', 'phone-purchases'],
    einvoice: ['invoices', 'quotations', 'guides', 'notes'],
    users: true
  },
  LOGISTICA: {
    inventory: ['products', 'suppliers', 'kardex-movements', 'document-register', 'tapers', 'phone-purchases'],
    einvoice: ['guides'],
    users: false
  },
  VENDEDOR: {
    inventory: ['products'],
    einvoice: ['invoices', 'quotations', 'notes'],
    users: false
  }
};

export const canPickInventoryStore = (user = getLoggedUser()) =>
  hasRole(['SUPER_ADMIN', 'LOGISTICA'], user);

export const canAccessModule = (section, module, user = getLoggedUser()) => {
  const role = normalizeRole(user?.role);
  const access = ROLE_ACCESS[role];
  if (!access) return false;
  if (section === 'users') return Boolean(access.users);
  return Array.isArray(access[section]) && access[section].includes(module);
};

export const getDefaultSerieForStore = (prefix, storeId, width = 3) => {
  const sid = Number(storeId);
  const safe = Number.isFinite(sid) && sid > 0 ? sid : 1;
  return `${prefix}${String(safe).padStart(width, '0')}`;
};

export const canAccessPath = (path, user = getLoggedUser()) => {
  const pathname = String(path || '');
  const role = normalizeRole(user?.role);

  if (!user || !role) return false;
  if (pathname === '/dashboard') return true;
  if (role === 'SUPER_ADMIN') return true;

  if (pathname.startsWith('/inventory/products')) return canAccessModule('inventory', 'products', user);
  if (pathname.startsWith('/inventory/suppliers')) return canAccessModule('inventory', 'suppliers', user);
  if (pathname.startsWith('/inventory/kardex-movements')) return canAccessModule('inventory', 'kardex-movements', user);
  if (pathname.startsWith('/inventory/document-register')) return canAccessModule('inventory', 'document-register', user);
  if (pathname.startsWith('/inventory/tapers')) return canAccessModule('inventory', 'tapers', user);
  if (pathname.startsWith('/inventory/phone-purchases')) return canAccessModule('inventory', 'phone-purchases', user);

  if (pathname.startsWith('/einvoice/invoices')) return canAccessModule('einvoice', 'invoices', user);
  if (pathname.startsWith('/einvoice/quotations')) return canAccessModule('einvoice', 'quotations', user);
  if (pathname.startsWith('/einvoice/guides')) return canAccessModule('einvoice', 'guides', user);
  if (pathname.startsWith('/einvoice/notes')) return canAccessModule('einvoice', 'notes', user);

  if (pathname.startsWith('/user-pages/users')) return canAccessModule('users', 'users', user);

  return false;
};
